import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status", "progress", "bar", "connection", "resume"]
  static values = { url: String, active: Boolean }

  connect() {
    this.stopped = false
    if (this.activeValue) this.schedule()
  }
  disconnect() { this.stopped = true; clearTimeout(this.timer); this.abort?.abort() }
  schedule() { if (!this.stopped) this.timer = setTimeout(() => this.poll(), 2500) }
  async poll() {
    this.abort = new AbortController()
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" }, signal: this.abort.signal })
      if (!response.ok) throw new Error("Progress unavailable")
      const data = await response.json()
      if (this.stopped) return
      const done = data.progress.done || 0, failed = data.progress.failed || 0, pending = data.progress.pending || 0
      this.statusTarget.textContent = data.status.charAt(0).toUpperCase() + data.status.slice(1)
      this.progressTarget.textContent = `${done} done · ${failed} need attention · ${pending} remaining`
      this.barTarget.value = done + failed
      this.connectionTarget.textContent = data.stalled ? "Work may have been interrupted. Resume the remaining shipments below." : "Work continues in the background. You can leave this page."
      if (this.hasResumeTarget) this.resumeTarget.hidden = !data.stalled
      if (!["queued", "running"].includes(data.status)) { window.location.reload(); return }
    } catch (error) {
      if (this.stopped) return
      this.connectionTarget.textContent = "Connection lost. Your work is saved; checking progress again…"
    }
    this.schedule()
  }
}
